import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

const MunicipalityOverview = ({ entities }) => {
  return (
    <div className="MunicipalityOverview">
      <div className="row mb-n8">
        {entities.map((entity) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);

          return (
            <div key={`${uuid}:${langcode}`} className="col-md-6 col-lg-4 mb-8">
              <Node
                id={id}
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default MunicipalityOverview;
